import React, { useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2"; // ⭐ SweetAlert2 import karein

const passwordLetterMessage = "Password must contain at least 6 letters";
const countPasswordLetters = (value) => (String(value).match(/[A-Za-z]/g) || []).length;

function VerifyOtp() {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email;

  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [isVerified, setIsVerified] = useState(false); 
  const [error, setError] = useState("");

  // Step 1: OTP Verify Karne ka function
  const handleVerify = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("https://uniformnx-com.onrender.com/parent/verify-otp", { email, otp });
      if (res.data.success) {
        setIsVerified(true); 
        setError("");
        
        // Chhota sa toast ya pop-up dikha sakte hain (Optional)
        Swal.fire({
          icon: 'success',
          title: 'OTP Verified',
          text: 'Now you can set your new password.',
          timer: 2000,
          showConfirmButton: false
        });
      }
    } catch (err) {
      setError(err.response?.data?.message || "Invalid OTP");
    }
  };

  // Step 2: Naya Password Save karne ka function
  const handleReset = async (e) => {
    e.preventDefault();
    if (!newPassword) return setError("Please enter a new password");
    if (countPasswordLetters(newPassword) < 6) return setError(passwordLetterMessage);

    try {
      const res = await axios.post("https://uniformnx-com.onrender.com/parent/reset-password-final", { email, newPassword });
      if (res.data.success) {
        
        // ⭐ Alert ki jagah stylish Pop-up
        Swal.fire({
          title: 'Updated!',
          text: 'Password Changed Successfully! ✅',
          icon: 'success',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Go to Login'
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/parent/login");
          }
        });

      }
    } catch (err) {
      setError("Failed to update password");
    }
  };

  if (!email) return <h3 className="text-center mt-5">Invalid Access</h3>;

  return (
    <div style={{ textAlign: "center", padding: "50px", display: "flex", justifyContent: "center", 
      backgroundImage: "url(https://png.pngtree.com/background/20210709/original/pngtree-cartoon-education-training-cram-school-picture-image_917042.jpg)",
      backgroundSize: "cover" }}>
      
      <div className="container mt-5 col-md-4">
        <form className="form-control p-4 shadow" style={{ background: "rgba(255,255,255,0.15)", backdropFilter: "blur(10px)", border: "1px solid rgba(255,255,255,0.3)" }}
          onSubmit={isVerified ? handleReset : handleVerify}>
          
          <h3 className="text-light mb-4">{isVerified ? "Create New Password" : "Verify OTP"}</h3>

          {!isVerified ? (
            /* --- OTP Input --- */
            <>
              <input type="text" placeholder="Enter OTP" className="form-control text-center mb-3" 
                onChange={(e) => { setOtp(e.target.value); setError(""); }} />
              <button type="submit" className="btn btn-outline-light w-100">Verify OTP</button>
            </>
          ) : (
            /* --- New Password Input --- */
            <>
              <input type="password" placeholder="Enter New Password" className="form-control text-center mb-3" 
                value={newPassword}
                onChange={(e) => {
                  const value = e.target.value;
                  setNewPassword(value);
                  setError(value && countPasswordLetters(value) < 6 ? passwordLetterMessage : "");
                }} />
              <button className="animated-btn btn border-1 w-75 border-light text-light"><span>Reset Password</span></button>
            </>
          )}

          {error && <p className="mt-3" style={{ color: "yellow", fontWeight: "500" }}>{error}</p>}
        </form>
      </div>
    </div>
  );
}

export default VerifyOtp;
